module.exports = __webpack_public_path__ + "img/active-check-ico.6b43bb31.svg";